const total = state => {
  return state.total
}

  export default {
    total,
  }
